export default "__VITE_ASSET__DKFTEHu___"